import { createRoot } from "react-dom/client";
import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import { initializeI18n } from "./i18n";
import App from "./App";
import "./index.css";
import "./styles/globals.css";

// Initialize i18n before rendering
initializeI18n().then(() => {
  const helmetContext = {};

  createRoot(document.getElementById("root")!).render(
    <HelmetProvider context={helmetContext}>
      <App />
    </HelmetProvider>
  );
});
